import React from 'react';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import FlatButton from 'material-ui/FlatButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import userContext from '../../services/userContext'
import OverlayController from '../overlay/OverlayController';
import AccountSettings from "../account/AccountSettings";
import { browserHistory } from 'react-router';
import './TaskboardAppBar.css';

class LoginButton extends React.Component {
    static muiName = 'FlatButton';

    constructor(props) {
        super(props);

        this.didTapLoginButton = this.didTapLoginButton.bind(this);
    }

    didTapLoginButton(event) {
        browserHistory.push('/login');
    }

    render() {
        return (
            <FlatButton {...this.props} style={{color: 'white'}} label="Login" onTouchTap={this.didTapLoginButton} />
        );
    }
}

class MenuIconButton extends React.Component {
    static muiName = 'IconMenu';

    constructor(props) {
        super(props);

        this.onAccountSettingsClick = this.onAccountSettingsClick.bind(this);
        this.didTapSignOutButton = this.didTapSignOutButton.bind(this);
    }

    onAccountSettingsClick() {
        OverlayController.showOverlay({
            component: <AccountSettings/>
        });
    }

    didTapSignOutButton(event) {
        OverlayController.showActivityIndicator();
        userContext.logout().then(() => {
            OverlayController.hideActivityIndicator();
            browserHistory.push('/');
        }, () => {
            OverlayController.hideActivityIndicator();
        });
    }

    render() {
        return (
            <IconMenu
                {...this.props}
                iconButtonElement={
                    <IconButton>
                        <MoreVertIcon color="white"/>
                    </IconButton>
                }
                anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                targetOrigin={{horizontal: 'right', vertical: 'top'}}
            >
                <MenuItem primaryText="Account Settings" onClick={this.onAccountSettingsClick} />
                <MenuItem primaryText="Sign out" onTouchTap={this.didTapSignOutButton} />
            </IconMenu>
        )
    }
}

class TaskboardAppBar extends React.Component {

    onTitleTouchTap() {
        browserHistory.push('/');
    }

    render() {
        let iconElementRight;
        if (this.props.isLoggedIn) {
            iconElementRight = <MenuIconButton/>;
        } else {
            iconElementRight = <LoginButton/>;
        }

        return (
            <div id="appBar" title="Nuevo Taskboard">
                <h1 onClick={this.onTitleTouchTap.bind(this)}>Nuevo Taskboard</h1>
                <div className="app-bar-flex-space"/>
                {iconElementRight}
            </div>
        )
    }
}

export default TaskboardAppBar;



// WEBPACK FOOTER //
// ./src/components/appBar/TaskboardAppBar.js